import { render, staticRenderFns } from "./InventoryPricingCRUDRow.vue?vue&type=template&id=2a8f68a0&scoped=true&"
import script from "./InventoryPricingCRUDRow.vue?vue&type=script&lang=js&"
export * from "./InventoryPricingCRUDRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f68a0",
  null
  
)

export default component.exports